'use strict';

import { IScope } from "angular";
import { isIP } from 'is-ip';
import { MasterSlaveSettings } from "../../../../../data/admin.data";
import { EServerMode } from "../../../../../data/socket.data";
import RestService from "../../../../../services/rest.service";

require('./admin.masterslave.component.css');

export default class AdminMasterSlaveSettingsComponent {
  public restrict: string;
  public template: any;
  public scope: any;
  public controller: any;
  public controllerAs: string;
  public bindToController: boolean;

  constructor() {
    this.restrict = 'EA';
    this.template = require('./admin.masterslave.component.html');
    this.scope = {
    };
    this.controller = AdminMasterSlaveComponentController;
    this.controllerAs = 'ctrl';
    this.bindToController = true;
  }
}

/* @ngInject */
class AdminMasterSlaveComponentController {
  private isLoading: boolean = false;
  private restService: RestService;
  private $scope: IScope;
  private settings: MasterSlaveSettings;
  private masterValid: boolean;
  private portValid: boolean;
  private intervalValid: boolean;

  constructor($scope: IScope, restService: RestService) {
    this.restService = restService;
    this.$scope = $scope;
    this.load();
  }


  /**
   * Load map settings
   */
  load() {
    this.isLoading = true;
    this.restService.loadMasterSlaveSettings().then(settings => {
      this.settings = settings;
    }).finally(() => {
      this.isLoading = false;
      this.validate();
      this.$scope.$applyAsync();
    });
  }

  /**
   * Save map settings
   */
  save() {
    this.isLoading = true;
    this.restService.saveMasterSlaveSettings(this.settings).then(response => {
      this.settings = response;
    }).finally(() => {
      this.isLoading = false;
      this.$scope.$applyAsync();
    });
  }

  setType(mode: EServerMode): void {
    this.settings.mode = mode;
    this.validate();
    this.$scope.$applyAsync();
  }

  private validate() {
    if (this.settings.mode === EServerMode.SLAVE) {
      this.validateMaster();
      this.validatePort();
      this.validateInterval();
    } else {
      this.masterValid = true;
      this.portValid = true;
      this.intervalValid = true;
    }
  }

  validateMaster() {

    const matchLocal = this.settings.masterIp.match(/^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/);
    const matchRemote = this.settings.masterIp.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+$/);

    const isLocal = matchLocal !== undefined && matchLocal !== null && matchLocal.length >= 0;
    const isRemote = matchRemote !== undefined && matchRemote !== null && matchRemote.length >= 0;

    this.masterValid = isIP(this.settings.masterIp) || isLocal || isRemote;
  }

  validatePort() {
    this.portValid = this.settings.masterPort && this.settings.masterPort > 0;
  }

  validateInterval() {
    this.intervalValid = this.settings.interval && this.settings.interval > 0;
  }
}
